<template>
  <h3>Activando usuario</h3>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { activate } from "@/services/medkusApi/publiccustomersService";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "CustomerActivateLayout",
  components: {},
  data() {
    return {
      passToken: "",
      isMedkus: false,
      responseMsg: "",
      errorRepeat: "",
      errorNew: ""
    };
  },
  setup() {
    const router = useRouter();
    return { router };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    async onLoad() {
      const tokenParam = this.$route.params.token;
      this.passToken = Array.isArray(tokenParam) ? tokenParam[0] : tokenParam ?? "";
      this.isMedkus = false;
      if (this.$route.params.isMedkus !== undefined) {
        this.isMedkus = this.$route.params.isMedkus === "1" ? true : false;
      }
      await this.validate();
    },
    async validate() {
      this.responseMsg = "";
      this.errorRepeat = "";
      this.errorNew = "";

      const body = {
        token: this.passToken,
      };

      let data = await activate(body)
        .then(response => response)
        .catch(() => {
          this.responseMsg = this.$t("An error occurred while activating your account.").toString();
          return null;
        });

      if (
        data == null ||
        data === undefined ||
        data.ok === undefined ||
        data.ok === false
      ) {
        this.responseMsg = this.$t(
          "Sorry your activation link is expired"
        ).toString();
        return;
      }

      this.responseMsg = this.$t(
        "Your registration has been completed!"
      ).toString();

      setTimeout(() => {
        this.router.push('/login');
      }, 1000);
    }
  }
});
</script>

<style scoped>
@import "../assets/css/helper.css";
@import "../assets/css/style.css";
@import "../assets/css/responsive.css";
</style>
